import { render } from "./parties.vue?vue&type=template&id=31788b02&scoped=true"
import script from "./parties.vue?vue&type=script&lang=js"
export * from "./parties.vue?vue&type=script&lang=js"

import "./parties.vue?vue&type=style&index=0&id=31788b02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31788b02"

export default script